import { ExportIcon, InformationIcon } from 'components/icons';
import { ShowRowsSelector } from 'components/segments';
import { Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP, subscriptionAccess } from 'config.js';
import querystring from 'querystring';
import { useExportMySegmentsListMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

/**
 *
 * @param {{pageSize:number, setPageSize:Function, globalFilter:string, setGlobalFilter:Function}} param0
 * @returns
 */
export default function TableHeaders({
  pageSize,
  setPageSize,
  globalFilter,
  setGlobalFilter,
}) {
  const { query } = useParseURLQueryParams();
  const { storeSubscriptionPlan } = useStoreSubscriptionPlan();

  const [
    exportMySegments,
    { isLoading: fileDownloading },
  ] = useExportMySegmentsListMutation();

  const handleExport = () => {
    const queryParams = querystring.stringify({
      store_name: query.store_name,
      export_format: 'csv',
    });

    exportMySegments({ serializedParams: queryParams });
  };

  return (
    <div className="flex items-center justify-between mt-12">
      <div className="flex items-center space-x-2 text-black text-opacity-70">
        <InformationIcon className="w-4 h-4" />
        <p className="italic text-right text-segments-13px">
          Shift + click to sort by multiple columns
        </p>
      </div>
      <div className="flex space-x-5">
        <ShowRowsSelector
          values={[10, 20, 30, 40, 50]} //* Arbitrary rows amount defined
          selected={pageSize}
          setSelected={setPageSize}
        />
        <input
          type="text"
          name="search"
          id="search"
          value={globalFilter || ''}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search segment..."
          className="pl-5 border-none rounded bg-segments-darker-gray"
        />
        <div>
          <Tooltip
            text={PAID_PLAN_TOOLTIP}
            disabled={
              !!!(
                storeSubscriptionPlan <
                subscriptionAccess.segmentsExportSegmentsList
              )
            }
          >
            <button
              className="p-3 rounded-full bg-segments-gray focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
              onClick={handleExport}
              disabled={
                fileDownloading ||
                storeSubscriptionPlan <
                  subscriptionAccess.segmentsExportSegmentsList
              }
            >
              {fileDownloading ? (
                <LoadingSpinner />
              ) : (
                <ExportIcon className="w-5 h-5 text-black" />
              )}
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

function LoadingSpinner() {
  return (
    <svg
      className="w-5 h-5 text-black animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}
